import { SimpleModal } from "../../components";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Col } from "react-bootstrap";
import { Order, UpsertOrderDTO, UpsertOrderDTOSchema } from "src/app/types/orders/order";
import { toast } from "react-toastify";
import { OrderTransport } from "src/app/transports/order";
import { SimpleFormControl } from "../../components/form/SimpleFormControl";
import { Form, Formik } from "formik";
import { number, object, string } from "yup";
import { IActionsModal } from "src/app/types/actionsModal";
import { useGetOrderById } from "src/app/hooks";
import Pacman from "src/app/components/layout/Pacman";

const UpsertURLOrderModalContainer = (props: IActionsModal<Order>) => {
    const { handleClose = () => {}, entity, updateGridOnSave = () => {} } = props;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();

    const { order, loading: orderLoading } = useGetOrderById(entity?.id);

    const regex = new RegExp(`${order?.rd?.domain}/`, "i");

    const upsertUrlDTOSchema = UpsertOrderDTOSchema.omit(["url", "orderPrice"]).concat(
        object({
            url: string()
                .matches(regex, "error.order.url.notmatchRD")
                .required("error.order.url.required"),
            orderPrice: number().required("error.order.orderPrice.required"),
            publishedAt: string().required("error.order.publishedAt.required"),
        })
    );

    const handleSubmit = async (_values: UpsertOrderDTO) => {
        setLoading(true);
        try {
            const res = await OrderTransport.addUrl(_values, entity?.id);
            await updateGridOnSave(res, false, true);
            toast.success(formatMessage({ id: "common.notification.success" }));
            setLoading(false);
            handleClose();
        } catch (error: any) {
            setLoading(false);
            toast.error(formatMessage({ id: "common.notification.error" }));
        }
        setLoading(false);
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.addUrl" })}
            handleClose={handleClose}
            loading={loading || orderLoading}
            formId="urlOrder"
            buttonConfirmationLabel={formatMessage({ id: "common.action.confirmation" })}
            showModal={true}
            modalProps={{ size: "lg" }}
        >
            {!order || orderLoading ? (
                <Pacman />
            ) : (
                <>
                    <Formik
                        initialValues={OrderTransport.formTransformer(order)}
                        validationSchema={upsertUrlDTOSchema}
                        onSubmit={handleSubmit}
                    >
                        <Form id="urlOrder">
                            <div className="urlOrderFormWrapper">
                                <label>RD</label>
                                {order?.rd?.domain}
                                <label>URL</label>
                                <SimpleFormControl name="url" />
                                <label>{formatMessage({ id: "common.field.price" })}</label>
                                <Col sm={4}>
                                    <SimpleFormControl
                                        name="orderPrice"
                                        min="0"
                                        type="number"
                                        step={1}
                                    />
                                </Col>
                                <label>{formatMessage({ id: "common.field.date" })}</label>
                                <Col sm={4}>
                                    <SimpleFormControl name="publishedAt" type="date" />
                                </Col>
                            </div>
                        </Form>
                    </Formik>
                </>
            )}
        </SimpleModal>
    );
};

export default UpsertURLOrderModalContainer;
